import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Hero } from '@cfm-media/pwa-ui-components';

import { LoadableStatus } from '../mobx-utils';
import { useStore } from '../core/store';
import { useTranslation } from '../core/utils/translations';
import { ContentWrapper } from '../components/content-wrapper';
import { Document } from '../components/documents/document';
import { ErrorPage } from '../components/error-page';
import { LoadSpinner } from '../components/loader';
import { PageWrapper } from '../components/page-wrapper';
import { urls } from '../urls';

export const Documents = observer(() => {
  const { t } = useTranslation(['documents-page', 'error-pages']);
  const navigate = useNavigate();

  const { BookingStore, DocumentStore } = useStore();
  const { booking } = BookingStore;
  const documents = DocumentStore?.documents;

  useEffect(() => {
    if (!documents?.data) documents?.fetch();
  }, []);

  //prettier-ignore
  if ([booking?.status, documents?.status].some((status) => status === LoadableStatus.error)) {
    return <DocumentsError />;
  } else if ([booking?.status, documents?.status].some((status) => status !== LoadableStatus.done)) {
    return <LoadSpinner />;
  }

  const documentData = documents?.data?.toJSON() || [];

  documentData.sort((left, right) => {
    return left.version > right.version ? -1 : 1;
  });

  return (
    <PageWrapper>
      <Hero
        image="/public/assets/images/teasers/documents.jpg"
        iconClass="icon-documents"
        headline="Dokumente"
        overlay
      />

      <ContentWrapper>
        {documentData?.length ? (
          <>
            <div className="hidden lg:block mb-3 text-xl text-brand-1 font-semibold uppercase">
              {t('documents-page-title-text')}
            </div>
            {documentData.map((doc, index) => (
              <Document
                key={index}
                date={doc?.createdAt}
                iconClass={'icon-documents'}
                link={doc?.link}
                version={doc?.version}
                blankCode={booking?.data?.id}
                type={doc?.type}
              />
            ))}
            <div className="flex justify-center">
              <Button
                onButtonClick={navigate.bind(null, urls.payment)}
                title={t('payment-page-button-text')}
                variant="primary"
              />
            </div>
          </>
        ) : (
          <ErrorPage
            title={t('error-pages:documents-empty-error-headline-text')}
            body={t('error-pages:documents-empty-error-body-text')}
            link={`mailto:info@bentour.de?subject=Buchung ${booking?.data?.id}`}
            buttonText={t('error-pages:documents-fetch-error-button-text')}
          />
        )}
      </ContentWrapper>
    </PageWrapper>
  );
});

export const DocumentsError = () => {
  const { t } = useTranslation('error-pages');

  return (
    <PageWrapper>
      <Hero
        image="/public/assets/images/teasers/documents.jpg"
        iconClass="icon-documents"
        headline="Dokumente"
        overlay
      />

      <ContentWrapper>
        <ErrorPage
          title={t('documents-fetch-error-title-text')}
          body={t('documents-fetch-error-body-text')}
          link={urls.home}
          buttonText={t('documents-fetch-error-button-text')}
        />
      </ContentWrapper>
    </PageWrapper>
  );
};
